module.exports = __webpack_public_path__ + "img/bao_gao.92da8939.jpg";